import { render, staticRenderFns } from "./AssignOwner.vue?vue&type=template&id=ae1a19ac&scoped=true"
import script from "./AssignOwner.vue?vue&type=script&lang=js"
export * from "./AssignOwner.vue?vue&type=script&lang=js"
import style0 from "./AssignOwner.vue?vue&type=style&index=0&id=ae1a19ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae1a19ac",
  null
  
)

export default component.exports